// removed by extract-text-webpack-plugin
module.exports = {"display-info":"DisplayInformation__display-info___V9c3U"};